import React, { useContext, useEffect, useState } from 'react'

import Select from 'react-select'

import { DBContext } from '../../../contexts/databases'
import { CharacterContext } from '../../../contexts/character'

import { getEnchant } from '../../../data/Items/enchants'

function EnchantSelect(props) {
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState([
		{
			value: 0,
			label: 'No enchant',
		},
	])
	const { item_db_equip, item_db_enchant, Item } = useContext(DBContext)
	const {
		job,
		inventory,
		replaceItemInInventory,
		maxRefine,
		searchAndSetOptions,
	} = useContext(CharacterContext)
	const refine = []
	if (props.Refinable)
		for (let i = 0; i <= props.MaxRefine; i++)
			refine.push(
				<option
					value={i}
					label={'+ ' + i}
					key={'ref' + props.Location + i}
				/>,
			)

	const changeLastSelectedItem = props.setLastSelectedItem
	const customStyles = props.styles
	useEffect(() => {
		let cardID = inventory[props.Location]?.CardSlots[props.Slot]?.ID
		searchAndSetOptions(options, cardID, setSelectedValue)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inventory[props.Location], options])

	useEffect(() => {
		// if (item_db_equip.length > 0) {
		let enchants = getEnchant(props.ItemID, props.Slot)
		let newOptions = []
		newOptions.push({ value: 0, label: 'No enchant', isFixed: true })
		if (item_db_enchant.length > 0) {
			for (let i = 0; i < enchants.length; i++) {
				let Ench = item_db_enchant.find(
					(ench) => ench.Id === enchants[i],
				)
				// Skip enchants missing from the DB to avoid crashing on undefined.
				if (!Ench) continue
				newOptions.push({
					value: Ench.Id,
					label: Ench.Name,
				})
			}
			setOptions(newOptions)
		}
		// }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_db_equip, job, props.ItemID])
	return (
		<Select
			menuPlacement='auto'
			styles={customStyles}
			value={selectedValue}
			id={props.id}
			onChange={(event) => {
				changeLastSelectedItem(event.value)
				let current = inventory[props.Location]
				//Create a new Item
				let newItem = new Item(
					props.Location,
					maxRefine[props.Location] > 0,
				)
				//Copy current Item
				newItem.setItem(current)
				//change refine level
				newItem.setRefine(current.refine)

				//add the new card and restore the others
				let newEnchant = item_db_enchant.find(
					(ench) => ench.Id === Number(event.value),
				)
				// console.log(newEnchant)
				if (!newEnchant)
					newEnchant = {
						Id: 0,
						AegisName: '0',
						Name: '',
						Type: 'Enchant',
						Script: '',
					}

				newItem.CardSlots.map((cardSlot, index) =>
					index === props.Slot
						? cardSlot.changeSlot(newEnchant)
						: cardSlot.changeSlot(current.CardSlots[index]),
				)
				searchAndSetOptions(options, newEnchant.Id, setSelectedValue)
				//apply new Item to Item slot
				replaceItemInInventory(newItem)
			}}
			className='equip'
			options={options}
		/>
	)
}

// function filterItems(item_db_equip, Location, job) {
// 	let Location2 = Location
// 	if (Location === 'Right_Accessory' || Location === 'Left_Accessory')
// 		Location2 = 'Both_Accessory'

// 	let filteredDB = item_db_equip.filter(
// 		(eq) =>
// 			(eq.Locations?.[Location] || eq.Locations?.[Location2]) &&
// 			(!eq.Jobs || eq.Jobs?.[jobsID.getFormatedBaseClassName(job)])
// 	)
// 	return filteredDB
// }

export default EnchantSelect
